//Principais
import { formatDate, registerLocaleData } from '@angular/common';
import myLocalePt from '@angular/common/locales/pt';
import { Component, inject, NgZone, OnInit, signal, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgSelectConfig } from "@ng-select/ng-select";
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { PlanoContingencia } from "src/app/shared/models/plano-contingencia/plano-contingencia";
import { PlanoMelhoria } from "src/app/shared/models/plano-melhoria/planoMelhoria";
import { NaoOcorrencia } from "src/app/shared/models/nao-ocorrencia/NaoOcorrencia";
import { Consolidado } from "src/app/shared/models/relatorio/Consolidado";
import { ListarCalendario } from "src/app/shared/models/relatorio/listar-calendario";
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { Chart, registerables } from 'chart.js';
import html2canvas from 'html2canvas';


//Services
import { RouterLink } from '@angular/router';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from "components/base/base.component";
import { CalendarioComponent } from 'components/calendario/calendario.component';
import { ModalAutorizacaoComponent } from 'components/modal-autorizacao-dados/modal-autorizacao.component';
import { ModalNotificacoesAlertComponent } from 'components/modal-notificacoes-alert/modal-notificacoes-alert.component';
import { TresPontosComponent } from 'components/tres-pontos/tres-pontos.component';
import { VisibilityManagerComponent } from 'components/visibility-manager/visibility-manager.component';
import { lastValueFrom } from "rxjs";
import { AlunosRecorrentes } from "src/app/shared/models/aluno/AlunosRecorrentes";
import { ListarEncaminhados } from "src/app/shared/models/chamados/listar-encaminhados";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { StatusPlanoMelhoria } from 'src/app/shared/enums/PlanoMelhoria/StatusPlanoMelhoria';
import { FiltroPadrao } from "src/app/shared/models/filtro-padrao/filtroPadrao";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { EncaminhamentoService } from "src/app/shared/services/encaminhamento.service";
import { NaoOcorrenciaService } from "src/app/shared/services/nao-ocorrencia.service";
import { RelatorioService } from "src/app/shared/services/relatorio.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { PlanoMelhoriaService } from "src/app/shared/services/plano-melhoria.service";
import { NotificacaoService } from 'src/app/shared/services/notificacao.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { FiltroPadraoPec } from "src/app/pages/pec/models/filtro-padrao-pec";
import { GraficoService } from "src/app/pages/pec/services/grafico.service";
import { ChartPecComponent, ElementoGrafico } from "../../components/chart-pec/chart-pec.component";

//Models
import { OcorrenciasPendentes } from "../../models/ocorrencias-pendentes";
import { OcorrenciasConcluidas } from "../../models/ocorrencias-concluidas";
import { DiasSemOcorrencias } from "../../models/dias-sem-ocorrencias";
import { AcoesPreventivas } from "../../models/acoes-preventivas";
import { AcoesAcolhimentoPOC } from "../../models/acoes-acolhimento-poc";
import { AcoesPreventivasPOC } from "../../models/acoes-preventivas-poc";
import { AcolhimentoPsicologo } from "../../models/acolhimento-psicologo";
import { PreencheramPMCE } from "../../models/preencheram-pmce";
import { NaoPreencheramPMCE } from "../../models/nao-preencheram-pmce";
import { PreencheramPlanoContingencia } from "../../models/preencheram-plano-contingencia";
import { NaoPreencheramPlanoContingencia } from "../../models/nao-preencheram-plano-contingencia";

@Component({
  selector: 'app-home-pec',
  templateUrl: './home-pec.component.html',
  styleUrls: ['./home-pec.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports, RouterLink,
    TresPontosComponent, NgbPagination, ModalAutorizacaoComponent, ModalNotificacoesAlertComponent, VisibilityManagerComponent, CalendarioComponent, NgChartsModule, ChartPecComponent]
})

export class HomePecComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  //Injeção
  config = inject(NgSelectConfig);
  chamadoService = inject(ChamadoService);
  encaminhamento = inject(EncaminhamentoService);
  relatorioService = inject(RelatorioService);
  naoOcorrenciaService = inject(NaoOcorrenciaService);
  graficoService = inject(GraficoService);
  override psicologoService = inject(PsicologoService);
  notificacaoService = inject(NotificacaoService);
  planoMelhoriaService = inject(PlanoMelhoriaService);
  private ngZone = inject(NgZone);
  public page = 1;
  public totalRegisterCount = 0;

  public get Psicologo() { return (this.atribuicoesLogin == undefined && this.userLogado?.flPsicologo); }
  public get CoordenadorPsicologo() { return this.userLogado?.DadosUsuario?.filter(s => s.CodigoPerfil == 1632).length }
  public get codigoPerfilAtual(): number {
    return Number(this.userLogado?.codigoPerfil ?? this.userLogado?.DadosUsuario?.[0]?.CodigoPerfil ?? 0);
  }
  public currentDate: string;
  public mesCalendario: number;
  public anoCalendario: number;
  public daysInMonth: { date: Date, isWeekend: boolean, isHoliday: boolean }[] = [];
  public qtdeCaracteresDescricao: number = 0;
  public showModalAdicionarChamado = false;
  public lstDiretorias: Diretoria[] = [];
  public lstEscolas: Escola[] = [];
  public lstTurnos: any[] = [];
  public lstPolos: any[] = [];
  public lstMunicipios: any[] = [];
  public lstTiposEnsino: any[] = [];
  public qtyAcoesAcolhimento: number = 0;
  public qtyAcoesPrevencao: number = 0;
  public ocorrenciasPendentes: OcorrenciasPendentes;
  public ocorrenciasConcluidas: OcorrenciasConcluidas;
  public diasSemOcorrencias: DiasSemOcorrencias;
  public acoesPreventivas: AcoesPreventivas;
  public acoesAcolhimentoPOC: AcoesAcolhimentoPOC;
  public acoesPreventivasPOC: AcoesPreventivasPOC;
  public acolhimentoPsicologo: AcolhimentoPsicologo;
  public preencheramPMCE: PreencheramPMCE;
  public naoPreencheramPMCE: NaoPreencheramPMCE;
  public preencheramPlanoContingencia: PreencheramPlanoContingencia;
  public naoPreencheramPlanoContingencia: NaoPreencheramPlanoContingencia;

  // Elementos para el gráfico de ocorrencias reutilizable
  public elementosOcorrencias: ElementoGrafico[] = [];
  public elementosDiasSemOcorrencias: ElementoGrafico[] = [];
  public elementosPMCE: ElementoGrafico[] = [];
  public elementosPlanoContingencia: ElementoGrafico[] = [];
  public elementosPsicologos: ElementoGrafico[] = [];
  public elementosPOC: ElementoGrafico[] = [];

  // Parâmetros para gráficos - computado uma única vez
  public parametros: FiltroPadraoPec = new FiltroPadraoPec();

  filtrosCalendarios = signal<FiltroPadrao | undefined>(undefined);

  // Mapping de funções para GetAcoes
  private actionMap: { [key: string]: () => Promise<void> } = {
    'GetOcorrenciasConcluidas': () => this.GetOcorrenciasConcluidas(),
    'GetGraphOcorrenciasPendentes': () => this.GetGraphOcorrenciasPendentes(),
    'GetDiasSemOcorrencias': () => this.GetDiasSemOcorrencias(),
    'GetPreencheramPMCE': () => this.GetPreencheramPMCE(),
    'GetNaoPreencheramPMCE': () => this.GetNaoPreencheramPMCE(),
    'GetPreencheramPlanoContingencia': () => this.GetPreencheramPlanoContingencia(),
    'GetNaoPreencheramPlanoContingencia': () => this.GetNaoPreencheramPlanoContingencia(),
    'GetAcoesPreventivas': () => this.GetAcoesPreventivas(),
    'GetAcolhimentoPsicologo': () => this.GetAcolhimentoPsicologo(),
    'GetAcoesPreventivasPOC': () => this.GetAcoesPreventivasPOC(),
    'GetAcoesAcolhimentoPOC': () => this.GetAcoesAcolhimentoPOC(),
  };

  constructor() {
    Chart.register(...registerables);
    Chart.defaults.devicePixelRatio = 1;
    super();
  }

  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  public showModal = false;
  public submittedModal = false;
  public tituloModal = '';
  public descricaoExclusao = '';
  public descricaoNaoOcorrencia = '';
  public dataOcorrenciaNaoOcorrencia = new Date();
  public chamadoARemover = 0;

  // FILTROS
  public gravidades = [{ id: 1, name: 'Amarelo' }, { id: 2, name: 'Vermelho' }];
  public lstChamados: ListarChamados[] = [];
  public lstAllChamados: ListarChamados[] = [];
  public alunosRecorrentes: AlunosRecorrentes[] = [];
  public listaDias: ListarCalendario[] = [];
  public chamadoFiltrado: number = 0;
  public formHomeNaoOcorrencia!: FormGroup;
  public lstDadosGrafico: ListarChamados[] = [];

  public get formNaoOco() { return this.formHomeNaoOcorrencia.controls; }

  // MODAL
  public submitted = false;
  public showPesquisa = false;
  public showModalExcluirChamado = false;
  public showModalNotificacao = false;
  public showModalCalendarioOcorrencia = false;
  public showModalCadastraNaoOcorrencia = false;
  public codigoChamadoSelected: number;
  public codigoEnvolvidoSelected: number;
  public formModal!: FormGroup;
  public get modalForm() { return this.formModal.controls; }

  //MODAL ENCERRAMENTO CHAMADO ENVOLVIDO
  public ShowModalEncerrarChamado = false;
  public descricaoEncerrarChamado = "";
  public chamadoEncerrarChamado = 0;

  //MODAL CONCLUIR CHAMADO
  public chamadoSeleccionado: ListarChamados;
  public item: ListarChamados;
  public showModalConcluirChamado = false;
  public descricaoConcluir = "";
  public chamadoAConcluir = 0;
  public chamadoHistorico: ListarChamados;

  //Modal notificação
  public lstChamadosAtrasados: ListarChamados[] = [];
  public lstPlanosContingenciaPendentes: PlanoContingencia[] = [];
  public lstPlanosMelhoriaPendentes: PlanoMelhoria[] = [];
  public contagemPlanoContingenciaValidacao = 0;
  public contagemPmceValidacao = 0;
  public mensagemNotificacao: string[] = [];

  /**
   * Export the dashboard content to PDF using html2canvas and pdfmake
   * Captures the visible content with all styles applied
   */
  public async exportarPDF() {
    this.ngZone.runOutsideAngular(async () => {
      try {
        this.spinnerService.show();

        // Dynamic imports para pdfmake/html2canvas
        // @ts-ignore
        const pdfmake = (await import('pdfmake/build/pdfmake')).default;
        // @ts-ignore
        const pdfFonts = await import('pdfmake/build/vfs_fonts');
        // @ts-ignore
        const html2canvas = (await import('html2canvas')).default;

        pdfmake.vfs = pdfFonts.pdfMake.vfs;

        // Esconde o botão PDF
        const pdfButton = document.querySelector('.section-titulo .card') as HTMLElement;
        const pdfButtonDisplay = pdfButton?.style.display || '';
        if (pdfButton) pdfButton.style.display = 'none';

        // Seleciona seções
        const sectionTitulo = document.querySelector('.section-titulo') as HTMLElement;
        const sectionConteudo = document.querySelector('.section-conteudo') as HTMLElement;
        const ngxSpinner = document.querySelector('ngx-spinner') as HTMLElement;
        if (ngxSpinner) ngxSpinner.style.display = 'none';

        // A4 landscape em pt: ~842 x 595
        const pageWidthPt = 842;
        const pageMargins = 20;            // margem em cada lado
        const maxContentWidth = pageWidthPt - pageMargins * 2;

        // helper para capturar elemento
        const captureElement = async (
          element: HTMLElement | null
        ): Promise<{ image: string; width: number; height: number } | null> => {
          if (!element) return null;

          const rect = element.getBoundingClientRect();

          // neutraliza efeito de zoom (devicePixelRatio)
          const dpr = window.devicePixelRatio || 1;
          const captureScale = 1 / dpr;

          const canvas = await html2canvas(element, {
            scale: captureScale,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            logging: false,
            width: rect.width,
            height: rect.height,
            windowWidth: rect.width,
            windowHeight: rect.height
          });

          const img = canvas.toDataURL('image/png');

          const ratio = canvas.width / canvas.height;
          const targetWidth = maxContentWidth;
          const targetHeight = targetWidth / ratio;

          return {
            image: img,
            width: targetWidth,
            height: targetHeight
          };
        };

        const content: any[] = [];

        // Título
        if (sectionTitulo) {
          const result = await captureElement(sectionTitulo);
          if (result) {
            content.push({
              image: result.image,
              width: result.width,
              height: result.height,
              margin: [0, 0, 0, 10],
              alignment: 'center'
            });
          }
        }

        // Espaço
        content.push({ text: '\n', margin: [0, 0, 0, 0] });

        // Conteúdo (gráficos + cards)
        if (sectionConteudo) {
          const result = await captureElement(sectionConteudo);
          if (result) {
            content.push({
              image: result.image,
              width: result.width,
              height: result.height,
              margin: [0, 0, 0, 0],
              alignment: 'center'
            });
          }
        }

        if (content.length > 0) {
          const docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            // margens em pt: [esquerda, topo, direita, baixo]
            margins: [pageMargins, pageMargins, pageMargins, pageMargins],
            content,
            compress: true
          };

          pdfmake.createPdf(docDefinition).download('relatorio-pec.pdf');
          this.ngZone.run(() => this.toastr.success('PDF gerado com sucesso!'));
        } else {
          this.ngZone.run(() => this.toastr.error('Nenhum conteúdo para exportar'));
        }

        // restaura elementos
        if (pdfButton) pdfButton.style.display = pdfButtonDisplay;
        if (ngxSpinner) ngxSpinner.style.display = '';

        this.spinnerService.hide();
      } catch (error) {
        console.error('Erro ao exportar PDF:', error);
        this.ngZone.run(() => this.toastr.error('Erro ao exportar PDF'));
        this.spinnerService.hide();
      }
    });
  }


  public async ngOnInit() {

    this.formHomeNaoOcorrencia = new FormGroup({
      dsChamado: new FormControl(null)
    });

    const DateObj = new Date();
    this.anoCalendario = DateObj.getFullYear();
    this.mesCalendario = DateObj.getMonth();

    if (this.atribuicoesLogin.CodigoPerfil != 112) {
      this.router.navigate(['/']);
    }

    // Load initial data in parallel
    this.spinnerService.show();
    await Promise.all([
      this.carregarContagemPendenciasValidacao(),
      this.getChamadosAtrasados()
    ]).finally(() => {
      this.spinnerService.hide();
    });
  }

  public async generateDaysInMonth() {
    registerLocaleData(myLocalePt);

    const daysInMonth = new Date(this.anoCalendario, this.mesCalendario + 1, 0).getDate();
    const parametros = this.SetParametrosCalendario(this.anoCalendario, this.mesCalendario + 1);

    this.spinnerService.show();


    if (this.filtros.atividadeDiretoria !== false) {
      const response = await lastValueFrom(this.relatorioService.getCalendarioOcorrencias(parametros))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.listaDias = response.data;
      this.daysInMonth = [];

      for (let i = 1; i <= daysInMonth; i++) {
        const day = new Date(this.anoCalendario, this.mesCalendario, i);
        const isWeekend = day.getDay() === 0 || day.getDay() === 6;
        const isHoliday = this.isHoliday(day);
        this.daysInMonth.push({ date: day, isWeekend, isHoliday });
      }
    }

    this.spinnerService.hide();
  }

  public async goToPreviousMonth() {
    const date = new Date(this.currentDate);
    date.setMonth(date.getMonth() - 1);

    if (this.mesCalendario == 0) {
      this.anoCalendario -= 1;
      this.mesCalendario = 11;
    } else
      this.mesCalendario -= 1;

    this.currentDate = `${this.anoCalendario}-${this.mesCalendario + 1}-01`;
    await this.generateDaysInMonth();
  }

  public async goToCurrentMonth() {
    const date = new Date(this.currentDate);
    date.setMonth(date.getMonth() + 1);

    if (this.mesCalendario == 11) {
      this.anoCalendario += 1;
      this.mesCalendario = 0;
    } else
      this.mesCalendario += 1;

    this.currentDate = `${this.anoCalendario}-${this.mesCalendario + 1}-01`;
    await this.generateDaysInMonth();
  }

  public isCurrentDay(day: Date): boolean {
    const today = new Date();
    return day.getFullYear() === today.getFullYear() &&
      day.getMonth() === today.getMonth() &&
      day.getDate() === today.getDate();
  }

  public isHoliday(day: Date): boolean {
    // Implemente a lógica para verificar se o dia é um feriado
    // Retorne true se for um feriado, caso contrário, retorne false
    // Por exemplo:
    // return (day.getDate() === 25 && day.getMonth() === 11); // Natal (25 de dezembro)
    return false; // Por enquanto, não consideramos nenhum feriado
  }

  public async onDateChange(event: any) {
    await this.generateDaysInMonth();
  }

  public formatarMes(date: string): string {
    const mes = new Date(date);
    return formatDate(mes, 'LLLL', 'pt');
  }

  public formatarDiaSemana(date: Date): string {
    return formatDate(date, 'EEEE', 'pt-br');
  }

  async getChamadosAtrasados() {
    if (this.userLogado!.modalVisto == true) {
      return;
    }
    this.spinnerService.show();

    const parametros = this.SetParametrosChamados();
    const result = await lastValueFrom(this.chamadoService.getChamadosEnvolvidos(parametros))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.lstChamadosAtrasados = result.data;
    if (this.lstChamadosAtrasados.length > 0) {
      this.showModalNotificacao = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }
    this.spinnerService.hide();
  }

  public async carregarContagemPendenciasValidacao() {
    this.contagemPlanoContingenciaValidacao = 0;
    this.contagemPmceValidacao = 0;
    const codigoPerfil = this.codigoPerfilAtual;
    if (codigoPerfil !== Perfil.PEC) {
      return;
    }

    const response = await lastValueFrom(
      this.notificacaoService.getContagemPendenciasValidacao(
        this.userLogado?.codigoDiretoria ?? 0,
        this.userLogado?.codigoEscola ?? 0,
        Perfil.PEC
      )
    ).catch((err) => this.convivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      await this.carregarContagemPendenciasValidacaoLegado();
      return;
    }

    const d = response.data as {
      planoContingenciaPendentes?: number;
      PlanoContingenciaPendentes?: number;
      pmcePendentes?: number;
      PmcePendentes?: number;
    };
    // PEC não valida mais Plano de Contingência — ignorar contagem de PC
    this.contagemPlanoContingenciaValidacao = 0;
    this.contagemPmceValidacao = Number(d?.pmcePendentes ?? d?.PmcePendentes ?? 0);

    // Se o endpoint novo existir mas retornar 0 (ex.: ambiente desatualizado), confere com a consulta legada.
    if (this.contagemPmceValidacao === 0) {
      await this.carregarContagemPendenciasValidacaoLegado();
      return;
    }

    if (this.contagemPmceValidacao > 0) {
      this.showModalNotificacao = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }
  }

  /**
   * Fallback para ambientes sem endpoint novo de contagem.
   * PEC não valida mais Plano de Contingência — só conta PMCE.
   */
  private async carregarContagemPendenciasValidacaoLegado() {
    this.lstPlanosContingenciaPendentes = [];
    this.contagemPlanoContingenciaValidacao = 0;

    const pmcePec = await lastValueFrom(
      (this.userLogado?.codigoEscola ?? 0) !== 0
        ? this.planoMelhoriaService.getPlanoMelhoriaPorEscolaEStatus(
            this.userLogado?.codigoEscola ?? 0,
            StatusPlanoMelhoria.AguardandoValidacaoPecConviva
          )
        : this.planoMelhoriaService.getPlanoMelhoriaPorDiretoriaEStatus(
            this.userLogado?.codigoDiretoria ?? 0,
            StatusPlanoMelhoria.AguardandoValidacaoPecConviva
          )
    ).catch((err) => this.convivaErrors.handleResultError(err));

    this.lstPlanosMelhoriaPendentes = pmcePec?.isSucess ? (pmcePec.data ?? []) : [];
    this.contagemPmceValidacao = this.lstPlanosMelhoriaPendentes.length;

    if (this.contagemPmceValidacao > 0) {
      this.showModalNotificacao = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }
  }

  public async getDiretorias() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.lstDiretorias = response.data;
    this.spinnerService.hide();
  }

  public async getEscolas(diretoriaLogada: boolean = false) {
    const codigoDE = this.filtros.codigoDiretoria;
    if (codigoDE != null) {
      this.spinnerService.show();
      const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.lstEscolas = response.data;
      this.spinnerService.hide();
    }
  }

  public async getCalendario() {
    this.mesCalendario = new Date().getMonth();
    this.anoCalendario = new Date().getFullYear();
    this.currentDate = `${this.anoCalendario}-${this.mesCalendario + 1}-01`;
    await this.generateDaysInMonth();
  }

  public zerarTurma() {
    this.turmas = [];
  }

  public onPageChange() {
    if (this.validaSePrecisaBuscarMaisRegistrosNaApi()) return;
    this.PesquisarChamados();
  }

  private validaSePrecisaBuscarMaisRegistrosNaApi(): boolean {
    return this.page * 5 <= this.lstChamados.length
  }

  public async PesquisarChamados() {
    this.submitted = true;
    this.spinnerService.show();
    this.showPesquisa = true;
    const parametros = this.SetParametrosChamados();
    const result = await lastValueFrom(this.chamadoService.getChamadosEnvolvidos(parametros))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.lstChamados = result.data;
    this.lstAllChamados = result.data;
    this.totalRegisterCount = result.totalCount!;
    if (this.CoordenadorPsicologo)
      this.lstChamados = this.lstChamados.filter(s => s.aluno?.statusEnvolvido === 1);
    if (this.lstChamados.length == 0) {
      this.alunosRecorrentes = []; // Zerar Alunos Recorrentes
      this.toastr.warning("Não existem chamados para essa pesquisa");
      this.spinnerService.hide();
      return;
    }
    await this.getAlunosRecorrentes(parametros);
  }

  public async getAlunosRecorrentes(parametros: ListarChamados) {
    this.spinnerService.show();
    if (parametros.atividadeDiretoria == false) {
      const result = await lastValueFrom(this.chamadoService.getAlunosRecorrentes(parametros))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.alunosRecorrentes = result.data;
      this.spinnerService.hide();
    }
  }

  public SetParametrosChamados(): ListarChamados {
    const chamado = new ListarChamados();
    chamado.codigoDiretoria = this.filtros.codigoDiretoria;
    chamado.codigoEscola = this.filtros.codigoEscola;
    chamado.codigoTurno = this.filtros.codigoTurno;
    chamado.codigoTurma = this.filtros.codigoTurma;
    chamado.codigoGravidade = this.filtros.codigoGravidade;
    chamado.codigoChamado = this.chamadoFiltrado;
    chamado.ordenacaoCrescente = false;
    chamado.anoAtual = this.filtros.anoAtual;
    chamado.pagina = this.page;
    chamado.atividadeDiretoria = this.userLogado?.apenasDiretoria ?? this.filtros.atividadeDiretoria!;
    return chamado;
  }

  public SetParametrosCalendario(ano: number, mes: number): Consolidado {
    const parametros = new Consolidado();
    parametros.codigoDiretoria = this.filtros.codigoDiretoria;
    parametros.codigoEscola = this.filtros.codigoEscola;
    parametros.ano = ano;
    parametros.mes = mes;
    return parametros;
  }

  public setParametrosEventoNotificacao(): ListarEncaminhados {
    const chamado = new ListarEncaminhados();
    if (this.userLogado != null && this.userLogado.codigoDiretoria != null)
      chamado.codigoDiretoria = this.userLogado.codigoDiretoria;
    if (this.userLogado != null && this.userLogado.codigoEscola != null)
      chamado.codigoEscola = this.userLogado.codigoEscola;
    return chamado;
  }

  public OnInserirOcorrenciaNaoOcorrencia(DataOcorrencia: Date, EstatusDia: number) {
    const dataOco = formatDate(DataOcorrencia, 'yyyy-MM-dd', 'en_US');
    const hoje = formatDate(new Date, 'yyyy-MM-dd', 'en_US');

    const dateOco = new Date();

    if (dataOco > hoje || !(EstatusDia == 4 || EstatusDia == 1))
      this.toastr.warning("Data não valida para uma ação");
    else {
      this.showModalCalendarioOcorrencia = true;
      this.dataOcorrenciaNaoOcorrencia = DataOcorrencia;
    }
  }

  public FecharModalExclusao() {
    this.showModalExcluirChamado = false;
    this.descricaoExclusao = "";
    this.chamadoARemover = 0;
  }

  public FecharModalCalendario() {
    this.showModalCalendarioOcorrencia = false;
    this.descricaoNaoOcorrencia = "";
  }

  public async InserirRegistroNaoOcorrencia() {
    let descricao = this.formHomeNaoOcorrencia.get('dsChamado')!.value;
    if (descricao == null)
      descricao = 'Nao houve chamados para o periodo selecionado';
    await this.getDiretorias();
    await this.getEscolas();
    const dir = this.lstDiretorias.filter(r => r.codigoDiretoria == this.filtros.codigoDiretoria)[0];
    const esc = this.lstEscolas.filter(r => r.codigoEscola == this.filtros.codigoEscola)[0];
    const objetoChamado: NaoOcorrencia = {
      cdGravidade: 0,
      cdCategoria: 13,
      cdSubCategoria: 42,
      dtNaoOcorrencia: formatDate(this.dataOcorrenciaNaoOcorrencia, 'yyyy-MM-dd', 'en_US'),
      cdDiretoria: dir.codigoDiretoria,
      nmDiretoria: dir.nomeDiretoria,
      cdEscola: esc.codigoEscola,
      nmEscola: esc.nomeEscolaSemCodigo,
      dsNaoOcorrencia: descricao,
      cdTurno: 0,
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      cdNaoOcorrencia: 0
    };

    const result = await lastValueFrom(await this.naoOcorrenciaService.setCadastrarNaoOcorrencia(objetoChamado))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Chamado cadastrado com sucesso.');
    this.formNaoOco.dsChamado.setValue(null);

    setTimeout(() => {
      this.submitted = false;
      document.getElementById("btnLimpar")?.click();
    }, 2000);

    this.showModalCadastraNaoOcorrencia = false;
    this.showModalCalendarioOcorrencia = false;
    await this.generateDaysInMonth();
  }

  public InserirOcorrencia() {
    const dt = this.dataOcorrenciaNaoOcorrencia;
    this.router.navigate(['/cadastrar-chamados/', dt]);
  }

  public InserirNaoOcorrencia() {
    this.showModalCadastraNaoOcorrencia = true;
    this.descricaoNaoOcorrencia = "";
  }

  public AbrirModal(codigoChamado: number, codigoEnvolvido: number) {
    this.codigoChamadoSelected = codigoChamado;
    this.codigoEnvolvidoSelected = codigoEnvolvido;
    this.submittedModal = false;
    this.formModal = new FormGroup({
    });
    this.showModal = true;
    this.tituloModal = 'Encaminhamentos';
  }

  public FecharModal() {
    this.showModal = false;
  }

  public async EncaminhamentoPsicologo() {
    this.spinnerService.show();
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado ao Psicólogo.',
      statusChamado: 2,//Encaminhado
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };
    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamento(objetoHistorico))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Aluno Encaminhado ao Psicologo com Sucesso.');
    this.FecharModal();
    this.PesquisarChamados();
  }

  public async EncaminhamentoPolicia() {
    this.spinnerService.show();
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado a Rede protetiva.',
      statusChamado: 2,//Encaminhado
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoPolicia(objetoHistorico))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Aluno Encaminhado a Rede protetiva.');
    this.FecharModal();
    this.PesquisarChamados();
  }

  public async EncaminhamentoSaude() {
    this.spinnerService.show();
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado a Saúde.',
      statusChamado: 3,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoSaude(objetoHistorico))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Aluno Encaminhado a Saúde com Sucesso.');
    this.FecharModal();
    this.PesquisarChamados();
  }

  public Proximamente() {
    this.toastr.warning("Esta funcionalidade será implementada futuramente");
  }

  public OnVisualizarChamado(id: number) {
    this.router.navigate(['/detalhe/', id]);
  }

  public FormatarDescricaoOcr(dsOcorrencia: string): string {
    if (dsOcorrencia != null) {
      if (dsOcorrencia.length > 80)
        return dsOcorrencia.substring(0, 80) + ' ...';
      else
        return dsOcorrencia;
    }
    return '--';
  }

  public getStatusEnvolvido(status: number | undefined): string | undefined {
    if (status != undefined) {
      const statusViagem = new Map<number, string>([
        [0, 'Não Analisado'],
        [1, 'Encaminhado ao Psicólogo'],
        [2, 'Encaminhado a Rede de Proteção'],
        [3, 'Encaminhado ao Hospital'],
        [4, 'Psicólogo Agendado'],
        [5, 'Atendimento Realizado'],
        [6, 'Concluído'],
      ]);
      return statusViagem.get(status);
    }
    return 'Não Analisado';
  }

  public getCorStatusEnvolvido(status: number | undefined): string | undefined {
    if (status != undefined) {
      const statusViagem = new Map<number, string>([
        [0, 'aberto'],
        [1, 'encaminhado'],
        [2, 'encaminhado'],
        [3, 'encaminhado'],
        [4, 'agendado'],
        [5, 'atendido'],
        [6, 'encerrado'],
      ]);
      return statusViagem.get(status);
    }
    return 'aberto';
  }

  public FiltraChamadosAtuais(event: any) {
    if (event.target?.value) {
      this.filtros.codigoGravidade = event.target.value;
    } else {
      this.filtros.codigoGravidade = undefined;
    }
  }

  public OnChangeCountLetters() {
    const descricao = this.formHomeNaoOcorrencia.get('dsChamado')!.value;
    if (descricao != null)
      this.qtdeCaracteresDescricao = descricao.length;
  }

  public EventTresPontos(event: string) {
    if (event === "Pesquisar") {
      this.PesquisarChamados();
    }
  }

  public FiltrarChamadoId(event: any) {
    if (event.target?.value) {
      this.chamadoFiltrado = event.target.value;
    }
    else
      this.chamadoFiltrado = 0;
  }

  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.spinnerService.show();
    // Limpiar elementos del gráfico para empezar fresco
    this.elementosOcorrencias = [];
    this.elementosDiasSemOcorrencias = [];
    this.elementosPMCE = [];
    this.elementosPlanoContingencia = [];
    this.elementosPsicologos = [];
    this.elementosPOC = [];

    this.setFilters(eventFilter);

    // Step 1: Load chamados data first (required for other operations)
    await this.PesquisarChamados();

    // Step 2: Compute graph parameters
    this.computarParametrosGrafico();

    // Step 3: Load all graph and plan data in parallel to optimize performance
    await Promise.all([
      // Ocorrências
      await this.GetOcorrenciasConcluidas(),
      await this.GetGraphOcorrenciasPendentes(),
      // Dias sem ocorrências
      await this.GetDiasSemOcorrencias(),
      await this.GetDiasSemOcorrencias2(),
      // PMCE
      await this.GetPreencheramPMCE(),
      await this.GetNaoPreencheramPMCE(),
      // Planos de Contingência e Melhoria
      await this.carregarContagemPendenciasValidacao(),
      // Psicólogos
      await this.GetAcoesPreventivas(),
      await this.GetAcolhimentoPsicologo(),
      // POC
      await this.GetAcoesPreventivasPOC(),
      await this.GetAcoesAcolhimentoPOC(),
      // Plano de Contingência (additional metrics)
      await this.GetPreencheramPlanoContingencia(),
      await this.GetNaoPreencheramPlanoContingencia()
    ]).finally(() => {
      this.spinnerService.hide();
    });
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
    this.filtrosCalendarios.set(this.filtros);

    // Load filter lists for display names
    this.loadFilterDisplayData();
  }

  /**
   * Load filter list data when a filter is selected
   * This populates lstTurnos, lstDiretorias, lstEscolas, lstPolos for display name lookups
   */
  private async loadFilterDisplayData() {
    // Load diretorias if not already loaded
    if (this.lstDiretorias.length === 0) {
      await this.getDiretorias();
    }

    // Load municipios when a diretoria is selected
    if (this.filtros?.codigoDiretoria) {
      await this.getMunicipios();
    }

    // Load escolas when a diretoria is selected
    if (this.filtros?.codigoDiretoria) {
      await this.getEscolas();
    }

    // Load turnos when a escola is selected
    if (this.filtros?.codigoEscola) {
      await this.getTurnos();
    }

    // Load polos if not already loaded
    if (this.lstPolos.length === 0) {
      await this.getPolos();
    }
  }

  /**
   * Get list of available turnos for the selected school
   */
  public async getTurnos() {
    const codigoEscola = this.filtros?.codigoEscola;
    if (!codigoEscola) {
      this.lstTurnos = [];
      return;
    }

    const result = await lastValueFrom(
      this.escolaService.getTurnosPorCodigoCie(codigoEscola)
    ).catch((err) => {
      return this.convivaErrors.handleResultError(err);
    });

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar turnos');
      this.lstTurnos = [];
      return;
    }

    this.lstTurnos = result.data ?? [];
  }

  /**
   * Get list of available polos
   */
  public async getPolos() {
    const result = await lastValueFrom(
      this.psicologoService.getPolos()
    ).catch((err) => {
      return this.convivaErrors.handleResultError(err);
    });

    if (!result?.isSucess) {
      this.lstPolos = [];
      return;
    }

    this.lstPolos = result.data ?? [];
  }

  /**
   * Get list of available municipios for the selected diretoria
   */
  public async getMunicipios() {
    const codigoDiretoria = this.filtros?.codigoDiretoria;
    if (!codigoDiretoria) {
      this.lstMunicipios = [];
      return;
    }

    const result = await lastValueFrom(
      this.escolaService.getMunicipiosPorDiretoria(codigoDiretoria)
    ).catch((err) => {
      return this.convivaErrors.handleResultError(err);
    });

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar municípios');
      this.lstMunicipios = [];
      return;
    }

    this.lstMunicipios = result.data ?? [];
  }

  /**
   * Get the display name for the selected directory (Diretoria)
   */
  public getNomeDiretoria(): string {
    if (!this.filtros?.codigoDiretoria) return '';
    // First try to find in the lstDiretorias array
    const diretoria = this.lstDiretorias.find(d => d.codigoDiretoria === this.filtros.codigoDiretoria);
    if (diretoria?.nomeDiretoria) return diretoria.nomeDiretoria;

    // Fallback: try to get from escola which also contains nomeDiretoria
    const escola = this.lstEscolas.find(e => e.codigoDiretoria === this.filtros.codigoDiretoria);
    return escola?.nomeDiretoria ?? '';
  }

  /**
   * Get the display name for the selected school (Escola)
   */
  public getNomeEscola(): string {
    if (!this.filtros?.codigoEscola) return '';
    const escola = this.lstEscolas.find(e => e.codigoEscola === this.filtros.codigoEscola);
    return escola?.nomeEscola ?? '';
  }

  /**
   * Get the display name for the selected shift (Turno)
   */
  public getNomeTurno(): string {
    if (!this.filtros?.codigoTurno) return '';
    const turno = this.lstTurnos.find(t => t.codigoTurno === this.filtros.codigoTurno);
    return turno?.nomeTurno ?? '';
  }

  /**
   * Get the display name for the selected polo
   */
  public getDescricaoPolo(): string {
    if (!this.filtros?.codigoPolo) return '';
    const polo = this.lstPolos.find(p => p.codigoPolo === this.filtros.codigoPolo);
    return polo?.descricaoPolo ?? '';
  }

  /**
   * Get the display name for the selected teaching type (Tipo Ensino)
   */
  public getNomeTipoEnsino(): string {
    // nomeTipoEnsino is stored directly in the filtros object
    return this.filtros?.nomeTipoEnsino ?? '';
  }

  /**
   * Get the display name for the selected municipality (Município)
   */
  public getNomeMunicipio(): string {
    if (!this.filtros?.codigoMunicipio) return '';
    const municipio = this.lstMunicipios.find(m => m.codigoMunicipio === this.filtros.codigoMunicipio);
    return municipio?.nomeMunicipio ?? '';
  }

  /**
   * Get the display name for the selected year (Ano)
   */
  public getAnoAtual(): string {
    return this.filtros?.anoAtual?.toString() ?? '';
  }

  public SetParametrosGrafico(): FiltroPadraoPec {
    const pamatroGrafico = new FiltroPadraoPec();
    pamatroGrafico.codigoPolo = this.filtros.codigoPolo;
    pamatroGrafico.codigoDiretoria = this.filtros.codigoDiretoria;
    pamatroGrafico.codigoMunicipio = this.filtros.codigoMunicipio ?? 0;
    pamatroGrafico.codigoEscola = this.filtros.codigoEscola ?? 0;
    pamatroGrafico.codigoTurno = this.filtros.codigoTurno ?? 0;
    pamatroGrafico.codigoTipoEnsino = this.filtros.codigoTipoEnsino;
    pamatroGrafico.nomeTipoEnsino = this.filtros.nomeTipoEnsino;
    pamatroGrafico.anoAtual = this.filtros.anoAtual;
    pamatroGrafico.atividadeDiretoria = this.userLogado?.apenasDiretoria ?? this.filtros.atividadeDiretoria!;
    return pamatroGrafico;
  }

  public computarParametrosGrafico(): void {
    this.parametros = this.SetParametrosGrafico();
  }

  /**
   * Helper genérico unificado para carregar dados de gráficos e atualizar elementos
   * Suporta chamadas de serviço com ou sem valores padrão
   * @param elementosArrayKey Chave da propriedade de elementos (ex: 'elementosOcorrencias')
   * @param label Label do elemento
   * @param cor Cor do elemento
   * @param errorMessage Mensagem de erro customizada
   * @param serviceMethod Método do serviço a ser chamado
   * @param parametros Parâmetros já computados para o serviço
   * @param valorKey Chave do valor no resultado
   * @param percentualKey Chave do percentual no resultado
   * @param defaultValor Valor padrão em caso de erro (null = falha sem continuar)
   * @param defaultPercentual Percentual padrão em caso de erro
   */
  private async updateElementoGrafico(
    elementosArrayKey: keyof HomePecComponent,
    label: string,
    cor: string,
    errorMessage: string = 'Erro ao carregar gráfico',
    serviceMethod?: ((params: FiltroPadraoPec) => any) | null,
    parametros?: FiltroPadraoPec,
    valorKey?: string,
    percentualKey?: string,
    defaultValor?: number | null,
    defaultPercentual?: number | null
  ): Promise<void> {

    try {
      let valor: number;
      let percentual: number;

      if (serviceMethod) {

        const result = await lastValueFrom(serviceMethod(parametros!))
          .catch((err) => this.convivaErrors.handleResultError(err)) as any;

        const temValoresDefault =
          defaultValor !== null && defaultValor !== undefined &&
          defaultPercentual !== null && defaultPercentual !== undefined;

        if (!result?.isSucess) {
          this.toastr.error(result?.message || errorMessage);
          if (!temValoresDefault) {
            this.spinnerService.hide();
            return;
          }
          valor = defaultValor!;
          percentual = defaultPercentual!;
        } else {
          valor = result.data[valorKey!];
          percentual = result.data[percentualKey!];
        }
      } else {
        valor = defaultValor ?? 0;
        percentual = defaultPercentual ?? 0;
      }

      const elementosArray = this[elementosArrayKey] as ElementoGrafico[];
      const elementos = [...elementosArray];
      const indice = elementos.findIndex(e => e.label === label);

      const novoElemento: ElementoGrafico = {
        label,
        valor,
        percentual,
        cor
      };

      if (indice === -1) {
        elementos.push(novoElemento);
      } else {
        elementos[indice] = novoElemento;
      }

      (this[elementosArrayKey] as ElementoGrafico[]) = elementos;

      if (elementosArrayKey === 'elementosPOC') {
        const poc = this.elementosPOC;

        if (poc.length === 2) {
          const totalFinal =
            (poc[0].valor ?? 0) +
            (poc[1].valor ?? 0);

          if (totalFinal > 0) {
            poc[0].percentual = +(((poc[0].valor ?? 0) * 100) / totalFinal).toFixed(2);
            poc[1].percentual = +(((poc[1].valor ?? 0) * 100) / totalFinal).toFixed(2);
          } else {
            poc[0].percentual = 0;
            poc[1].percentual = 0;
          }
        }
      }

      this.chart?.update();
    } catch (error) {
      console.error(errorMessage, error);
      this.toastr.error(errorMessage);
    }
  }

  public async GetOcorrenciasConcluidas() {
    await this.updateElementoGrafico(
      'elementosOcorrencias',
      'Concluídas',
      '#62B368',
      'Erro ao carregar gráfico Ocorrências Concluídas',
      (params) => this.graficoService.GetDataGraphOcorrenciasConcluidas(params),
      this.parametros,
      'ocorrenciasConcluidas',
      'percentualConcluidas'
    );
  }

  public async GetGraphOcorrenciasPendentes() {
    await this.updateElementoGrafico(
      'elementosOcorrencias',
      'Pendentes',
      '#CB2525',
      'Erro ao carregar gráfico Ocorrências Pendentes',
      (params) => this.graficoService.GetDataGraphOcorrenciasPendentes(params),
      this.parametros,
      'ocorrenciasPendentes',
      'percentualPendentes'
    );
  }

  public async GetDiasSemOcorrencias() {
    await this.updateElementoGrafico(
      'elementosDiasSemOcorrencias',
      'Sem Ocorrências',
      '#1351B4',
      'Erro ao carregar dados de dias sem ocorrências',
      (params) => this.graficoService.GetGraphDiasSemOcorrencias(params),
      this.parametros,
      'diasSemOcorrencias',
      'percentualDiasSemOcorrencias'
    );
  }

  // NOTE: This method is deprecated and not used - it has an empty label which prevents display
  // Consider removing if no longer needed
  public async GetDiasSemOcorrencias2() {
    await this.updateElementoGrafico(
      'elementosDiasSemOcorrencias',
      '',
      '#1351B4',
      'Erro ao carregar dados de dias sem ocorrências',
      null,
      undefined,
      undefined,
      undefined,
      0,
      0
    );
  }

  public async GetPreencheramPMCE() {
    await this.updateElementoGrafico(
      'elementosPMCE',
      'Preenchidos',
      '#7A7B8E',
      'Erro ao carregar gráfico Preencheram PMCE',
      (params) => this.graficoService.GetDataGraphPreencheramPMCE(params),
      this.parametros,
      'preencheramPMCE',
      'percentualPreencheramPMCE'
    );
  }

  public async GetNaoPreencheramPMCE() {
    await this.updateElementoGrafico(
      'elementosPMCE',
      'Não Preenchidos',
      '#4B4C58',
      'Erro ao carregar gráfico Não Preencheram PMCE',
      (params) => this.graficoService.GetDataGraphNaoPreencheramPMCE(params),
      this.parametros,
      'naoPreencheramPMCE',
      'percentualNaoPreencheramPMCE'
    );
  }

  public async GetPreencheramPlanoContingencia() {
    await this.updateElementoGrafico(
      'elementosPlanoContingencia',
      'Preenchidos',
      '#E566AA',
      'Erro ao carregar gráfico Preencheram Plano de Contingência',
      (params) => this.graficoService.GetPreencheramPlanoContingencia(params),
      this.parametros,
      'preencheramPlanoContingencia',
      'percentualPreencheramPlanoContingencia'
    );
  }

  public async GetNaoPreencheramPlanoContingencia() {
    await this.updateElementoGrafico(
      'elementosPlanoContingencia',
      'Não Preenchidos',
      '#871251',
      'Erro ao carregar gráfico Não preencheram Plano de Contingência',
      (params) => this.graficoService.GetNaoPreencheramPlanoContingencia(params),
      this.parametros,
      'naoPreencheramPlanoContingencia',
      'percentualNaoPreencheramPlanoContingencia'
    );
  }

  public async GetAcoesPreventivas() {
    await this.updateElementoGrafico(
      'elementosPsicologos',
      'Ações Preventivas',
      '#9D80CB',
      'Erro ao carregar gráfico Ações Preventivas',
      (params) => this.graficoService.GetDataGraphAcoesPreventivas(params),
      this.parametros,
      'acoesPreventivas',
      'percentualAcoesPreventivas'
    );
  }

  public async GetAcolhimentoPsicologo() {
    await this.updateElementoGrafico(
      'elementosPsicologos',
      'Acolhimento',
      '#432B6E',
      'Erro ao carregar gráfico Acolhimento Psicológo',
      (params) => this.graficoService.GetDataGraphAcolhimentoPsicologo(params),
      this.parametros,
      'acolhimentoPsicologo',
      'percentualAcolhimentoPsicologo'
    );
  }

  public async GetAcoesPreventivasPOC() {
    await this.updateElementoGrafico(
      'elementosPOC',
      'Ações Preventivas',
      '#95CCC8',
      'Erro ao carregar gráfico Ações Preventivas do POC',
      (params) => this.graficoService.GetDataGraphAcoesPreventivasPOC(params),
      this.parametros,
      'acoesPreventivasPOC',
      'percentualAcoesPreventivasPOC'//,
      //0,
      //0
    );
  }

  public async GetAcoesAcolhimentoPOC() {
    await this.updateElementoGrafico(
      'elementosPOC',
      'Acolhimentos',
      '#116E67',
      'Erro ao carregar gráfico Ações de Acolhimento do POC',
      (params) => this.graficoService.GetDataGraphAcoesAcolhimentoPOC(params),
      this.parametros,
      'acoesAcolhimentoPOC',
      'percentualAcoesAcolhimentoPOC'//,
      //0,
      //0
    );
  }

  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
  }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
  }
}
